export enum FrageGetriebe {
  SCHALTGETRIEBE = 'schaltgetriebe',

  AUTOMATIKGETRIEBE = 'automatikgetriebe',
}
